import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import { bytesToHex } from '@stacks/common';
import { base58CheckDecode, base58CheckEncode } from '@stacks/encryption';
import { AddressHashMode, ClarityType } from '@stacks/transactions';
import { StackingErrors } from './constants';
export var InvalidAddressError =
/*#__PURE__*/
function (_Error) {
  _inherits(InvalidAddressError, _Error);

  function InvalidAddressError(address, innerError) {
    var _this;

    _classCallCheck(this, InvalidAddressError);

    var msg = "".concat(address, " is not a valid P2PKH or P2SH address -- native P2WPKH and native P2WSH are not supported in PoX.");
    _this = _possibleConstructorReturn(this, _getPrototypeOf(InvalidAddressError).call(this, msg));
    _this.message = msg;
    _this.name = _this.constructor.name;
    _this.innerError = innerError;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
    }

    return _this;
  }

  return InvalidAddressError;
}(_wrapNativeSuper(Error));
export var BitcoinNetworkVersion = {
  mainnet: {
    P2PKH: 0x00,
    P2SH: 0x05
  },
  testnet: {
    P2PKH: 0x6f,
    P2SH: 0xc4
  }
};
export function btcAddressVersionToHashMode(btcAddressVersion) {
  switch (btcAddressVersion) {
    case BitcoinNetworkVersion.mainnet.P2PKH:
      return AddressHashMode.SerializeP2PKH;

    case BitcoinNetworkVersion.testnet.P2PKH:
      return AddressHashMode.SerializeP2PKH;

    case BitcoinNetworkVersion.mainnet.P2SH:
      return AddressHashMode.SerializeP2SH;

    case BitcoinNetworkVersion.testnet.P2SH:
      return AddressHashMode.SerializeP2SH;

    default:
      throw new Error('Invalid pox address version');
  }
}
export function hashModeToBtcAddressVersion(hashMode, network) {
  if (!['mainnet', 'testnet'].includes(network)) {
    throw new Error("Invalid network argument: ".concat(network));
  }

  switch (hashMode) {
    case AddressHashMode.SerializeP2PKH:
      return BitcoinNetworkVersion[network].P2PKH;

    case AddressHashMode.SerializeP2SH:
      return BitcoinNetworkVersion[network].P2SH;

    default:
      throw new Error("Invalid pox address hash mode: ".concat(hashMode));
  }
}
export function getAddressHashMode(btcAddress) {
  try {
    var _base58CheckDecode = base58CheckDecode(btcAddress),
        version = _base58CheckDecode.version;

    return btcAddressVersionToHashMode(version);
  } catch (error) {
    throw new InvalidAddressError(btcAddress, error);
  }
}
export function decodeBtcAddress(btcAddress) {
  try {
    var b58Result = base58CheckDecode(btcAddress);
    var hashMode = btcAddressVersionToHashMode(b58Result.version);
    return {
      hashMode: hashMode,
      data: b58Result.hash
    };
  } catch (error) {
    throw new InvalidAddressError(btcAddress, error);
  }
}
export function extractPoxAddressFromClarityValue(poxAddrClarityValue) {
  var clarityValue = poxAddrClarityValue;

  if (clarityValue.type !== ClarityType.Tuple || !clarityValue.data) {
    throw new Error('Invalid argument, expected ClarityValue to be a TupleCV');
  }

  if (!('version' in clarityValue.data) || !('hashbytes' in clarityValue.data)) {
    throw new Error('Invalid argument, expected Clarity tuple value to contain `version` and `hashbytes` keys');
  }

  var versionCV = clarityValue.data['version'];
  var hashBytesCV = clarityValue.data['hashbytes'];

  if (versionCV.type !== ClarityType.Buffer || hashBytesCV.type !== ClarityType.Buffer) {
    throw new Error('Invalid argument, expected Clarity tuple value to contain `version` and `hashbytes` buffers');
  }

  return {
    version: versionCV.buffer,
    hashBytes: hashBytesCV.buffer
  };
}
export function poxAddressToBtcAddress() {
  var version, hashBytes, network;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 3) {
    version = args[0];
    hashBytes = args[1];
    network = args[2];
  } else if (args.length === 2) {
    var _extractPoxAddressFro = extractPoxAddressFromClarityValue(args[0]);

    version = _extractPoxAddressFro.version;
    hashBytes = _extractPoxAddressFro.hashBytes;
    network = args[1];
  } else {
    throw new Error('Invalid arguments');
  }

  if (version.byteLength !== 1) {
    throw new Error("Invalid byte length for version buffer: ".concat(bytesToHex(version)));
  }

  if (hashBytes.byteLength !== 20) {
    throw new Error("Invalid byte length for hashBytes: ".concat(bytesToHex(hashBytes)));
  }

  var btcNetworkVersion = hashModeToBtcAddressVersion(version[0], network);
  var btcAddress = base58CheckEncode(btcNetworkVersion, hashBytes);
  return btcAddress;
}
export function getBTCAddress(version, checksum) {
  var versionNumber = typeof version === 'number' ? version : version[0];
  return base58CheckEncode(versionNumber, checksum);
}
export function getErrorString(error) {
  switch (error) {
    case StackingErrors.ERR_STACKING_UNREACHABLE:
      return 'Stacking unreachable';

    case StackingErrors.ERR_STACKING_INSUFFICIENT_FUNDS:
      return 'Insufficient funds';

    case StackingErrors.ERR_STACKING_INVALID_LOCK_PERIOD:
      return 'Invalid lock period';

    case StackingErrors.ERR_STACKING_ALREADY_STACKED:
      return 'Account already stacked. Concurrent stacking not allowed.';

    case StackingErrors.ERR_STACKING_NO_SUCH_PRINCIPAL:
      return 'Principal does not exist';

    case StackingErrors.ERR_STACKING_EXPIRED:
      return 'Stacking expired';

    case StackingErrors.ERR_STACKING_STX_LOCKED:
      return 'STX balance is locked';

    case StackingErrors.ERR_STACKING_PERMISSION_DENIED:
      return 'Permission denied';

    case StackingErrors.ERR_STACKING_THRESHOLD_NOT_MET:
      return 'Stacking threshold not met';

    case StackingErrors.ERR_STACKING_POX_ADDRESS_IN_USE:
      return 'PoX address already in use';

    case StackingErrors.ERR_STACKING_INVALID_POX_ADDRESS:
      return 'Invalid PoX address';

    case StackingErrors.ERR_STACKING_ALREADY_REJECTED:
      return 'Stacking already rejected';

    case StackingErrors.ERR_STACKING_INVALID_AMOUNT:
      return 'Invalid amount';

    case StackingErrors.ERR_NOT_ALLOWED:
      return 'Stacking not allowed';

    case StackingErrors.ERR_STACKING_ALREADY_DELEGATED:
      return 'Already delegated';

    case StackingErrors.ERR_DELEGATION_EXPIRES_DURING_LOCK:
      return 'Delegation expires during lock period';

    case StackingErrors.ERR_DELEGATION_TOO_MUCH_LOCKED:
      return 'Delegation too much locked';

    case StackingErrors.ERR_DELEGATION_POX_ADDR_REQUIRED:
      return 'PoX address required for delegation';

    case StackingErrors.ERR_INVALID_START_BURN_HEIGHT:
      return 'Invalid start burn height';
  }
}